var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4167 0C4.65625 0 0 4.65625 0 10.4167C0 16.1771 4.65625 20.8333 10.4167 20.8333C16.1771 20.8333 20.8333 16.1771 20.8333 10.4167C20.8333 4.65625 16.1771 0 10.4167 0ZM10.4167 18.75C5.82292 18.75 2.08333 15.0104 2.08333 10.4167C2.08333 5.82292 5.82292 2.08333 10.4167 2.08333C15.0104 2.08333 18.75 5.82292 18.75 10.4167C18.75 15.0104 15.0104 18.75 10.4167 18.75ZM10.4167 8.94792L14.1562 5.20833L15.625 6.67708L11.8854 10.4167L15.625 14.1562L14.1562 15.625L10.4167 11.8854L6.67708 15.625L5.20833 14.1562L8.94792 10.4167L5.20833 6.67708L6.67708 5.20833L10.4167 8.94792Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.4d1f2946.svg";
export { ForwardRef as ReactComponent };